import {API_KOTLIN_DOMAIN} from "../config"
import {fetchData} from "../util"

/**
 * 查询操作日志列表
 * @param {Object} params - 查询参数
 * @param {string} params.clubId - 俱乐部ID
 * @param {number} [params.tableId] - 球台ID
 * @param {string} [params.operationType] - 操作类型中文
 * @param {number} [params.startTimestamp] - 开始时间（毫秒时间戳）
 * @param {number} [params.endTimestamp] - 结束时间（毫秒时间戳）
 * @param {number} [params.page] - 页码
 * @param {number} [params.count] - 每页条数
 */
export const fetchOperationLogs = async (params) => {
    const queryString = new URLSearchParams(params).toString()
    const endpoint = `${API_KOTLIN_DOMAIN}/employee/operationLogs?${queryString}`
    return fetchData(endpoint)
}

/**
 * 查询操作类型枚举列表
 */
export const fetchOperationTypes = async () => {
    const endpoint = `${API_KOTLIN_DOMAIN}/employee/operationLogs/types`
    return fetchData(endpoint)
}



// WEBPACK FOOTER //
// ./src/api/clubOperationLogs.js